import API from '../services/Api';

class UserService {
    async Auth(login) {
        return await API.post("Users/Auth", login)
    }
}
export default new UserService();